import React, { useState } from 'react'

const QuantityCounter = () => {
    const[quantity,setQuantity]=useState(1);
  return (
    <>
      <div className='flex items-center justify-center space-x-1 '>
            <button className={`border-[2px] px-[6px]  ${quantity===0? 'border-red-200':'border-red-700'} rounded-l-lg`} onClick={()=>{setQuantity(quantity-1)}} disabled={quantity===0}>-</button>
            <div className='border-[2px] px-[6px]'>{quantity}</div>
            <button className='border-[2px] px-[6px] border-green-400 rounded-r-lg' onClick={()=>{setQuantity(quantity+1)}}>+</button>
      </div>
    </>
  )
}

export default QuantityCounter
